export default __webpack_public_path__ + "static/giotto-5-9b4f1393fe207f04de30815a94ba3377.jpg";